import { AccountContactSearchRequest } from '@trukt/tms-api/AccountService';
import { createKey } from '../../../createKey';

const keyHandler = createKey('account-contact');

export const AccountContactServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<AccountContactSearchRequest>(),
};
